var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.label)?_c('li',{class:[_vm.active, 'tab'],on:{"click":_vm.changeTab}},[_vm._v(" "+_vm._s(_vm.label)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }